import mailVistaLoader from "@/assets/lotties/loader_v2.json";
import LogoutEscapeLink from "@/components/LogoutEscapeLink";
import { useBackgroundPreloader } from "@/contexts/BackgroundPreloaderContext";
import Lottie from "lottie-react";

type AppLoaderProps = {
    message?: string;
    withLogout?: boolean;
};

const AppLoader = ({ message, withLogout = true }: AppLoaderProps) => {
    const { backgroundImageUrl, hasBackgroundError } = useBackgroundPreloader();

    return (
        <div
            className="relative flex h-screen w-full flex-col bg-primary-darkest"
            style={
                hasBackgroundError
                    ? undefined
                    : {
                          backgroundImage: `url(${backgroundImageUrl})`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                      }
            }
        >
            <div className="flex flex-1 flex-col items-center justify-center">
                <Lottie
                    animationData={mailVistaLoader}
                    className="h-120 w-120"
                    loop
                />
                {message && (
                    <p className="mt-4 text-center font-body text-base text-white/90 drop-shadow-md">
                        {message}
                    </p>
                )}
            </div>
            {withLogout && (
                <div className="absolute inset-x-0 bottom-8 flex justify-center">
                    <LogoutEscapeLink className="text-white/90 drop-shadow-md hover:text-white" />
                </div>
            )}
        </div>
    );
};

export default AppLoader;
